import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from '@shared/services/dialog-service';
import {DialogModel} from '@shared/models/dialog.model';
import {take} from 'rxjs/operators';
import {DataMappingItem} from '@features/data-mapping/models/data-mapping.model';
import {Api} from '@shared/constants/common-field.constants';

@Injectable({
  providedIn: 'root'
})
export class ApplyDataMappingCommandHandler implements IPlatformCommandHandler {
  constructor(private dialogService: DialogService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const fileName = command.fieldValues['DirectoryEntryName'];
    const directExecute = command.fieldValues['DirectExecute'] as boolean;
    if (directExecute) {
      handler.executeCommand(command);
      return true;
    }
    const title = command.title ?? 'Import/Export By Field Mapping';
    const dialogModel = DialogModel.create(title, 'SelectDataMappingDialogComponent',
      {
        flowchartSectionId: command.fieldValues['FlowchartSectionId'],
        SourceType: command.fieldValues['SourceType'],
        FlowchartId: command.fieldValues['FlowchartId'],
        ItemId: command.fieldValues['ItemId'],
        DirectoryEntryId: command.fieldValues['DirectoryEntryId'],
        DirectoryEntryName: fileName,
        optionItems: command.fieldValues['OptionItems'],
        dataMappings: command.fieldValues['DataMappingItems'] ?? [],
        isFilterApplicable: command.fieldValues['IsFilterApplicable'] ?? false,
        dataMappingItemId: command.fieldValues['DataMappingItemId'],
        selectedActionId: command.fieldValues['SelectedAction'],
        noDataMappingFoundMessage: command.fieldValues['NoDataMappingFoundMessage'],
        dataMappingUrl: command.fieldValues['DataMappingUrl'],
        hasDataMappingItems: command.fieldValues['HasDataMappingItems'],
        optionItemPlaceholder: command.fieldValues['OptionItemPlaceholder'],
        ...command.fieldValues
      },
      '465px',
      '465px');
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res && res.action === 'OK') {
        const dataMappingItem = res.data.input['selectedMapping'] as DataMappingItem;
        if (res.data.input.dataMappingOption && res.data.input.dataMappingOption === 'create-new-questionnaire') {
          const platformCommand = new PlatformCommand('ExecuteCopyFileCommand', Api.FileStoreApi);
          platformCommand.fieldValues['ApplyDataTransformation'] = true;
          platformCommand.fieldValues['Overwrite'] = true;
          platformCommand.fieldValues['ShouldRedirect'] = true;
          platformCommand.fieldValues['DataMappingItemId'] = dataMappingItem.id;
          platformCommand.fieldValues['DataMappingItemName'] = dataMappingItem.name;
          platformCommand.fieldValues['CopyResponses'] = true;
          platformCommand.fieldValues['FileName'] = `${res.data.input['fileName']}.qnr`;
          Object.keys(command.fieldValues).forEach(key => {
            platformCommand.fieldValues[key] = command.fieldValues[key];
          });
          handler.executeCommand(platformCommand);
        } else {
          command.fieldValues['DataMappingItemId'] = dataMappingItem.id;
          command.fieldValues['DataMappingItemName'] = dataMappingItem.name;
          command.fieldValues['SelectedAction'] = res.data.input.dataMappingOption;
          if (res.data.input.sourceFilePath) {
            command.fieldValues['SourceFilePath'] = res.data.input.sourceFilePath;
          }
          if (res.data.input.fileName) {
            command.fieldValues['FileName'] = `${res.data.input['fileName']}.qnr`;
          }
          handler.executeCommand(command);
        }
      }
    });
    return false;
  }
}
